var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "collaborator-section d-md-flex flex-column flex-md-row" },
      _vm._l(_vm.collaborators, function(collaborator) {
        return _c("director-block", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.collapsed,
              expression: "collapsed"
            }
          ],
          key: collaborator.id,
          staticClass: "col-md-3",
          style: { paddingLeft: "6px" },
          attrs: {
            director: collaborator,
            role: collaborator.role,
            collapsed: _vm.collapsed
          }
        })
      }),
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.collapsed,
            expression: "!collapsed"
          }
        ],
        staticClass: "collaborator-section flex-row",
        style: { alignItems: "center" },
        on: { click: _vm.clickArrow }
      },
      [
        _c(
          "span",
          _vm._l(_vm.initialProfiles, function(profile, index) {
            return _c("profile-picture-initial", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: index < 5,
                  expression: "index<5"
                }
              ],
              key: index,
              style: {
                zIndex: _vm.initialProfiles.length - index,
                marginLeft: index === 0 ? 0 : "-8px"
              },
              attrs: { src: profile, size: 24 }
            })
          }),
          1
        ),
        _vm._v(" "),
        _c("span", { staticClass: "minimize-names" }, [
          _vm._v("\n      " + _vm._s(_vm.collaboratorNames) + "\n    ")
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }